// @flow
import React, { Component } from 'react';

import PageHeader from '../../PageHeader.jsx';
import ContentBox from '../../ContentBox.jsx';

import ProblemTable from './ProblemTable.jsx';
import MedicationTable from '../treatment/MedicationTable.jsx';
import InterventionTable from '../treatment/InterventionTable.jsx';

class ResolvedProblemsPage extends Component<{}> {
  render() {
    return (
      <div>
        <PageHeader title="Resolved Diagnoses & Treatments" />
        <ContentBox title='Diagnoses' id='diagnoses'>
          <ProblemTable resolved />
        </ContentBox>
        <ContentBox title='Medications' id='medications'>
          <MedicationTable resolved />
        </ContentBox>
        <ContentBox title='Interventions' id='interventions'>
          <InterventionTable resolved />
        </ContentBox>
      </div>
    );
  }
}

export default ResolvedProblemsPage;



// WEBPACK FOOTER //
// ./client/src/components/patientPages/problem/ResolvedProblemsPage.jsx